
<template>
    <div class="visitor-wrapper">
        <div class="visitor-img">
            <img class="img" src="~@/assets/images/bgtemp.png" alt="">
            <div v-if="deptName" class="desc">{{deptName}}</div>
        </div>
        <div>
            <div>
                <div class="form-group">
                    <div class="form-lable">提报时间</div>
                    <div class="form-control form-checkbox">
                        <ul class="form-checkbox">
                          <li class="item" :class="curIndex==index ? 'active':''" v-for="(item,index) in timeList" @click="handleCheckbox(index,item)" :key="index">
                            <div>{{item}}</div>
                          </li>
                        </ul>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-lable form-temperature">您的体温</div>
                    <div class="form-control form-input-wrapper">
                      <input @click="showPicker=true" v-model="temperature" class="form-input" type="text" placeholder="请选择温度" maxlength="100" readonly>
                      <van-popup v-model="showPicker" position="bottom">
                        <van-picker
                          title="温度值"
                          show-toolbar
                          :columns="columns"
                          @cancel="showPicker = false"
                          @confirm="onConfirm"
                        />
                      </van-popup>
                    </div>
                </div>
                <div class="form-group form-group-button">
                  <van-button :loading="loading" type="info" loading-text="提交中..." :class="actionDisable ? 'active' : ''" @click="handleSubmit" >提交登记</van-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Toast, Dialog, Picker, Popup, Button } from 'vant'
import { getVisitorInfo, submitVisitorInfo } from '@/api/depttemp'
import { setStore, removeStore } from '@/utils/index'

export default {
  components: {
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Button.name]: Button
  },
  data () {
    return {
      actionDisable: true,
      curIndex: null,
      timeList: ['早上', '中午', '晚上'],
      loading: false,
      showPicker: false,
      step: 0.1,
      deptName: '', // 机构名称，
      temperature: null, // 体温
      columns: [
        // 第一列
        {
          values: [35, 36, 37, 38, 39, 40],
          defaultIndex: 1
        },
        // 第二列
        {
          values: [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9],
          defaultIndex: 3
        }
      ]
    }
  },
  mounted () {
    const token = this.$route.query.token
    if (token) {
      setStore('token', token)
    }
    this.getData()
  },
  destroyed () {
    removeStore('token')
  },
  methods: {
    getData () {
      getVisitorInfo().then((res) => {
        if (res.data.code === 200) {
          // 赋值
          if (res.data && res.data.result) {
            this.actionDisable = false
            this.deptName = res.data.result.deptName
          } else {
            this.actionDisable = true
            Dialog({ message: '您的信息还没有录入到系统中，请联系本公司管理员了解详情' })
          }
        }
      })
    },
    onConfirm (value) {
      console.log(value)
      if (Array.isArray(value)) {
        this.temperature = value[0] + value[1]
      }
      this.showPicker = false
    },
    handleSubmit (e) {
      e.preventDefault()
      if (this.actionDisable) {
        Dialog({ message: '您的信息还没有录入到系统中，请联系本公司管理员了解详情' })
        return
      }
      if (!this.type) {
        Toast({
          message: '请选择提报时间'
        })
        return
      }
      if (!this.temperature) {
        Toast({
          message: '请输入您的温度'
        })
        return
      }
      const data = {
        temp: this.temperature,
        type: this.type
      }
      this.loading = true
      submitVisitorInfo(data).then((res) => {
        console.log(res)
        this.loading = false
        if (res.data.code === 200) {
          this.$router.push('/msuc')
        }
      }).catch(() => {
        this.loading = false
      })
    },
    clearForm () {
      this.type = ''
      this.temperature = null
    },
    handleCheckbox (index, item) {
      console.log(index, item)
      if (this.curIndex !== index) {
        this.curIndex = index
        this.type = this.curIndex + 1
      } else {
        this.curIndex = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  /deep/ .van-button--info{
    background-color: #4f7cf6;
    border-color: #4f7cf6;
    width: 90%;
    border-radius: 40px;
  }
  /deep/ .van-button--info.active {
    opacity: 0.7;
  }
  .visitor-wrapper {
      min-height: 120vh;
      background: #f7f7f7;
  }
  .visitor-img {
      position: relative;
      margin: 0 15px;
      padding: 10px 0 5px;
      overflow: hidden;
      .img {
        width: 100%;
        border-radius: 5px;
      }
      .desc {
        position: absolute;
        bottom: 9px;
        box-sizing: border-box;
        width: 100%;
        padding: 3px 16px 3px;
        background: rgba(0, 0, 0, .3);
        text-align: right;
        font-size: 12px;
        color: #fff;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
      }
  }
  .form-lable {
      box-sizing: border-box;
      width: 100%;
      padding: 8px 15px;
      background-color: #f7f7f7;
      font-size: 14px;
  }
  .form-temperature {
    margin-bottom: 6px;
  }
  .form-control {
      box-sizing: border-box;
      width: 100%;
      padding: 12px 15px;
      background-color: #fff;
      font-size: 14px;
  }
  .form-input-wrapper {
      padding: 3px 15px;
  }
  .form-input {
      box-sizing: border-box;
      width: 98%;
      padding: 9px 3px;
  }
  .form-checkbox {
      display: flex;
      .item {
        margin-right: 20px;
        padding: 3px 8px;
        border: 1px solid #e2e2e2;
        border-radius: 5px;
        background-color: #f7f7f7;
        font-size: 14px;
      }
      .item.active {
        border: 1px solid #4f7cf6;
        background-color: #4f7cf6;
        color: #fff;
      }
  }
  .form-group-button {
      display: flex;
      justify-content: center;
      padding: 30px;
      border: 1px solid transparent;
  }
  .form-button {
      width: 92%;
      padding: 8px 0;
      border-radius: 30px;
      background-color: #4f7cf6;
      font-size: 16px;
      color: #fff;
  }
</style>
